import { IconButton, Badge, colors } from '@material-ui/core';
import React from 'react';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import clsx from 'clsx';
import useStyles from '../styles';
import { requiredLogin } from '../../../../middlewares';
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt';

const BoltButton = () => {
  const classes = useStyles({});
  return (
    <IconButton
      style={{ background: colors.grey['200'] }}
      color="secondary"
      className={clsx(classes.navbarElementSpacing)}
    >
      <OfflineBoltIcon />
    </IconButton>
  );
};

export default requiredLogin(BoltButton);
